import React from 'react';
import { ArrowLeftIcon, ShieldIcon, UserIcon, UsersIcon, BabyIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function AssessmentPage() {
  return <div className="w-full min-h-screen bg-[#f8f8f8] py-12 px-6" data-id="element-459">
      <div className="max-w-5xl mx-auto" data-id="element-460">
        {/* Back button */}
        <div className="mb-8" data-id="element-461">
          <Link to="/" className="flex items-center text-gray-600 hover:text-[#631bb7] transition-colors" data-id="element-462">
            <ArrowLeftIcon size={20} className="mr-2" data-id="element-463" />
            <span className="font-medium" data-id="element-464">Go Back</span>
          </Link>
        </div>

        {/* Main heading */}
        <div className="text-center mb-12" data-id="element-465">
          <h1 className="text-4xl md:text-5xl font-bold text-[#111111] mb-4" data-id="element-466">
            Who are you?
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-467">
            Select your role so we can personalize your experience
          </p>
        </div>

        {/* Options grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-468">
          {/* The Guardian */}
          <div className="bg-white rounded-2xl p-6 border-2 border-gray-200 flex flex-col h-full hover:border-[#631bb7] transition-colors" data-id="element-469">
            <div className="flex items-start mb-4" data-id="element-470">
              <div className="w-14 h-14 bg-[#631bb7] bg-opacity-5 rounded-2xl flex items-center justify-center border border-[#631bb7] border-opacity-10 mr-4 flex-shrink-0" data-id="element-471">
                <ShieldIcon size={28} className="text-[#631bb7]" data-id="element-472" />
              </div>
              <div data-id="element-473">
                <h2 className="text-2xl font-bold text-[#111111]" data-id="element-474">
                  The Guardian
                </h2>
                <p className="text-sm text-[#631bb7] font-semibold" data-id="element-475">
                  Primary Coordinator
                </p>
              </div>
            </div>
            <p className="text-gray-600 mb-6 leading-relaxed flex-grow" data-id="element-476">
              You're the family's tech shepherd — helping coordinate digital
              safety for parents, grandparents, or the whole household.
            </p>
            <div className="mt-auto" data-id="element-477">
              <Link to="/assessment/self" className="w-full bg-white border-2 border-[#631bb7] text-[#631bb7] px-4 py-3 rounded-lg font-bold flex items-center justify-center no-underline hover:bg-[#631bb7] hover:text-white transition-all" data-id="element-478">
                I'm the Guardian
              </Link>
            </div>
          </div>

          {/* The Adult */}
          <div className="bg-white rounded-2xl p-6 border-2 border-gray-200 flex flex-col h-full hover:border-[#631bb7] transition-colors" data-id="element-479">
            <div className="flex items-start mb-4" data-id="element-480">
              <div className="w-14 h-14 bg-[#631bb7] bg-opacity-5 rounded-2xl flex items-center justify-center border border-[#631bb7] border-opacity-10 mr-4 flex-shrink-0" data-id="element-481">
                <UsersIcon size={28} className="text-[#631bb7]" data-id="element-482" />
              </div>
              <div data-id="element-483">
                <h2 className="text-2xl font-bold text-[#111111]" data-id="element-484">The Adult</h2>
                <p className="text-sm text-[#631bb7] font-semibold" data-id="element-485">
                  Family Member
                </p>
              </div>
            </div>
            <p className="text-gray-600 mb-6 leading-relaxed flex-grow" data-id="element-486">
              You want help understanding and securing your technology with
              support from your family.
            </p>
            <div className="mt-auto" data-id="element-487">
              <Link to="/assessment/family" className="w-full bg-white border-2 border-[#631bb7] text-[#631bb7] px-4 py-3 rounded-lg font-bold flex items-center justify-center no-underline hover:bg-[#631bb7] hover:text-white transition-all" data-id="element-488">
                I'm an Adult Member
              </Link>
            </div>
          </div>

          {/* The Child */}
          <div className="bg-white rounded-2xl p-6 border-2 border-gray-200 flex flex-col h-full hover:border-[#631bb7] transition-colors" data-id="element-489">
            <div className="flex items-start mb-4" data-id="element-490">
              <div className="w-14 h-14 bg-[#631bb7] bg-opacity-5 rounded-2xl flex items-center justify-center border border-[#631bb7] border-opacity-10 mr-4 flex-shrink-0" data-id="element-491">
                <BabyIcon size={28} className="text-[#631bb7]" data-id="element-492" />
              </div>
              <div data-id="element-493">
                <h2 className="text-2xl font-bold text-[#111111]" data-id="element-494">The Child</h2>
                <p className="text-sm text-[#631bb7] font-semibold" data-id="element-495">
                  Minor Member
                </p>
              </div>
            </div>
            <p className="text-gray-600 mb-6 leading-relaxed flex-grow" data-id="element-496">
              You're a minor who's part of a family group. Your Guardian will
              help oversee your digital safety journey.
            </p>
            <div className="mt-auto" data-id="element-497">
              <Link to="/assessment/loved-one" className="w-full bg-white border-2 border-[#631bb7] text-[#631bb7] px-4 py-3 rounded-lg font-bold flex items-center justify-center no-underline hover:bg-[#631bb7] hover:text-white transition-all" data-id="element-498">
                I'm a Child
              </Link>
            </div>
          </div>

          {/* The Individual */}
          <div className="bg-white rounded-2xl p-6 border-2 border-gray-200 flex flex-col h-full hover:border-[#631bb7] transition-colors" data-id="element-499">
            <div className="flex items-start mb-4" data-id="element-500">
              <div className="w-14 h-14 bg-[#631bb7] bg-opacity-5 rounded-2xl flex items-center justify-center border border-[#631bb7] border-opacity-10 mr-4 flex-shrink-0" data-id="element-501">
                <UserIcon size={28} className="text-[#631bb7]" data-id="element-502" />
              </div>
              <div data-id="element-503">
                <h2 className="text-2xl font-bold text-[#111111]" data-id="element-504">
                  The Individual
                </h2>
                <p className="text-sm text-[#631bb7] font-semibold" data-id="element-505">
                  Solo User
                </p>
              </div>
            </div>
            <p className="text-gray-600 mb-6 leading-relaxed flex-grow" data-id="element-506">
              You're managing your own tech security solo. Perfect for building
              your own digital confidence.
            </p>
            <div className="mt-auto" data-id="element-507">
              <Link to="/assessment/self" className="w-full bg-white border-2 border-[#631bb7] text-[#631bb7] px-4 py-3 rounded-lg font-bold flex items-center justify-center no-underline hover:bg-[#631bb7] hover:text-white transition-all" data-id="element-508">
                I'm an Individual
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>;
}